import React, { useEffect } from 'react';
import { useWishlist } from '../wishlist/WishlistContext';
import { IconClose } from '../components/icons/AdminUiIcons';

export default function WishlistNoticeToast() {
  const { notice, dismissNotice } = useWishlist();

  useEffect(() => {
    if (!notice) return undefined;
    const t = window.setTimeout(() => dismissNotice(), 4500);
    return () => window.clearTimeout(t);
  }, [notice, dismissNotice]);

  if (!notice) return null;

  return (
    <div className="cart-added-toast wishlist-notice-toast" role="alert" aria-live="assertive">
      <div className="cart-added-toast__inner">
        <span className="cart-added-toast__check wishlist-notice-toast__icon" aria-hidden>
          !
        </span>
        <div className="cart-added-toast__text">
          <strong className="cart-added-toast__title">{notice}</strong>
        </div>
        <button type="button" className="cart-added-toast__close" aria-label="Dismiss" onClick={dismissNotice}>
          <IconClose width={14} height={14} />
        </button>
      </div>
    </div>
  );
}
